<template>
  <div class="main">
    <Header 
      :show="true"
      title="修改装车线信息"
      left="prepage" 
      right="" 
      :click-left="handleClickLeft" 
      :click-right="handleClickRight"
    />
    <div style="padding-bottom: 8vh;">
      <van-notice-bar
        left-icon="info-o"
        color="#ed6a0c" background="#FFFBE8" 
      text="注意：装车线产品非常重要，请谨慎修改"
      />
      <van-form 
        ref="update"
        @submit="submit"
      >
        <van-field
        v-model.trim="listQuery.name"
        label="名称"
        placeholder="请输入装车线名称"
        required
        :rules="[{ required: true, message: '' }]"
      />
      <van-field
        v-model.trim="listQuery.product"
        label="产品"
        placeholder="请选择产品"
        required
        :rules="[{ required: true, message: '' }]"
      />
      <van-field
        v-model.trim="listQuery.remark"
        rows="2"
        autosize
        label="说明"
        type="textarea"
        maxlength="100"
        placeholder="请输入装车线说明"
        show-word-limit
        />
        <div style="margin: .6rem 1rem;" v-if="checkPermission([122])">
          <van-button round block type="info" native-type="submit">
            确定
          </van-button>
        </div>
      </van-form>
    </div>
    <Footer value="service" />
  </div>
</template>

<script>
  import { Dialog } from 'vant'
  import { showPhoneAlarm } from '@/global/function.js'
  import checkPermission from '@/utils/permission'
  import Header from '@/views/components/header/index.vue'
  import Footer from '@/views/components/footer/index.vue'
  import { isUserName, isPassword, isChinese, isPhone, isEmail } from '@/utils/validate.js'
  import { getList as getProductList } from '@/api/product.js'
  import { updateOne } from '@/api/line.js'

  export default {
    name: 'SystemProductLineUpdate',
    components: {
      Header,
      Footer
    },
    inject: ['reload'],
    data() {
      return {
        isLoading: false,
        loading: false,
        listQuery: {
          serial: '',
          name: '',
          product: '',
          remark: ''
        },
        productOptions: []
      }
    },
    computed: {

    },
    watch: {
      
    },
    beforeCreate() {
      
    },
    created() {
      this.handleGetProductList()
    },
    beforeMount() {
      
    },
    mounted() {
      this.listQuery = this.$route.query
    },
    beforeUpdate() {
      
    },
    updated() {
      
    },
    beforeDestroy() {
      
    },
    destroyed() {
      
    },
    methods: {
      checkPermission,
      handleClickLeft() {
        this.$router.go(-1)
        // console.log('dashboard-left')
      },
      handleClickRight() {
        this.$refs.update.submit()
      },
      submit() {
        Dialog.confirm({
          title: '确认修改装车线设定？',
          message: '装车线：' + this.listQuery.serial + '号线'
        }).then(() => {
          const data = {
            id: this.listQuery.serial,
            name: this.listQuery.name,
            product: this.listQuery.product,
            remark: this.listQuery.remark
          }
          this.loading = true
          updateOne(data).then(response => {
            const { data } = response
            if (showPhoneAlarm(true, 'toast', null, 2000, data.code, '修改装车线', data.message)) {
              this.$router.push({ path:'/service/project/line', query: {} })
            }
            this.loading = false
          }).catch(function(error) {
            this.loading = false
            console.error(error)
          })
        }).catch(() => {
          showPhoneAlarm(true, 'toast', 'success', 2000, 200, '修改装车线', '取消')
        })
      },
      handleGetProductList() {
        const data = {
          page: 1,
          limit: 10000
        }
        getProductList(data).then(response => {
          const { data } = response
          if (showPhoneAlarm(false, 'toast', null, 2000, data.code, null, data.message)) {
            const items = data.data.items
            this.productOptions = []
            for (let i=0; i<items.length; i++) {
              this.productOptions.push({
                id: items[i].id,
                name: items[i].name
              })
            }
          }
        }).catch(function(error) {
          console.error(error)
        })
      },
      validName(value) {
        return new Promise((resolve) => {
          const result = isChinese(value, 2, 20)
          if (result === true) {
            resolve(true)
          } else {
            showPhoneAlarm(true, 'toast', null, 2000, null, result, null)
            resolve(false)
          }
        })
      },
    }
  }
</script>

<style lang="less" scoped>
  // 系统样式修改
  ::v-deep .van-field__label {
    width: 5em;
  }
  ::v-deep .van-field__control:read-only {
    color: #999;
  }
  ::v-deep .van-checkbox {
    padding: 3px 0;
  }
  ::v-deep .van-checkbox__icon {
    font-size: 4.5vw;
  }
  // 自定义样式
  .main {
    height: 100vh;
    font-size: 2vw;
    background-color: #FFFFFF;//#F8F8F8; 
    overflow-x: hidden;
    // overflow-y:hidden;
    overflow-y: auto;
    // display: flex; 
    // justify-content: center; 
    // align-items: center;
  }
</style>
